/**
 * Web shim for `@react-native/assets-registry/registry`.
 *
 * `react-native-svg` imports this registry to resolve numeric asset handles — the
 * values React Native's Metro bundler produces for `require('./image.png')`. A Vite
 * web build never creates those handles: image sources arrive as URL strings or
 * `{ uri }` objects, which `resolveAssetUri` handles without touching the registry.
 *
 * The real package is only published as part of the React Native distribution, which
 * this web-only app deliberately does not install. Throwing here keeps the dead branch
 * honest instead of silently returning a broken asset.
 */

export interface PackagerAsset {
  readonly httpServerLocation: string;
  readonly name: string;
  readonly type: string;
  readonly width?: number;
  readonly height?: number;
  readonly scales: readonly number[];
}

export function getAssetByID(assetId: number): PackagerAsset {
  throw new Error(
    `Numeric React Native asset handles are not supported on web (received ${String(assetId)}). ` +
      'Pass an image URL string or a { uri } object instead.'
  );
}

export function registerAsset(asset: PackagerAsset): number {
  throw new Error(`registerAsset is not supported on web (received "${asset.name}").`);
}

export default { getAssetByID, registerAsset };
